import Injection = EECore.Injection;
import { WidgetResources } from "../../resources/widget";
import NewsService from "../../services/news/newsService";
import NewsModelList from "../../services/entities/news/newsModelList";
import NewsModel from "../../services/entities/news/newsModel";
import NewsItem from "./newsItem";
import Model from "../models/news/newsModel";
import Unavailable from "../unavailable/unavailable";

@Injection.injectableClass("News")
export default class News implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("News", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("News", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("News", "NewsService")
  private newsService: NewsService;

  @Injection.injectableProperty("News", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("News", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("News", EECore.Registrations.UNAVAILABLE_SERVICE)
  private unavailableService: EECore.Services.UnavailableService;

  constructor(templateFactory: EECore.UI.TemplateFactory,
    newsService: NewsService, webComponentFactory: EECore.UI.WebComponentFactory,
    document: Document, resources: WidgetResources,
    unavailableService: EECore.Services.UnavailableService) {
    this.templateFactory = templateFactory;
    this.newsService = newsService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
    this.resources = resources;
    this.unavailableService = unavailableService;
  }
  load(container: Element): EECore.Promise<Element, string> {
    const title = container.getAttribute("ee-title");
    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.newsService.getLatest().then((newsModelList: NewsModelList) => {
        const template = this.renderTemplate(newsModelList.url, title);
        const newsContainer = template.querySelector(".content");
        this.unavailableService.getAvailabilityservice("EXT2_NEWS").then((availability: EECore.Services.Entities.UnavailableModel) => {
          if (availability.isAvailable === false) {
            newsContainer.appendChild(this.renderunavailable(availability));
          }
          else {
            newsContainer.appendChild(this.renderItems(newsModelList.news));
          }
          resolve(template);
        });
      }).catch(() => {
        reject("Could not get latest news.");
      });
    });
  }

  protected renderTemplate(url: string, title?: string): Element {
    const model = new Model();
    model.titleLabel = title || this.resources.news.titleLabel;
    model.buttonLabel = this.resources.news.buttonLabel;
    model.url = url;
    return this.templateFactory.getTemplate("News", model);
  }

  protected renderunavailable(unavailableModel: EECore.Services.Entities.UnavailableModel): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    const newsItem = this.webComponentFactory.getWebComponent(Unavailable) as Unavailable;
    newsItem.model = unavailableModel;
    documentFragment.appendChild(newsItem.load());
    return documentFragment;
  }

  protected renderItems(news: NewsModel[]): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    for (let i = 0; i < news.length; i++) {
      const newsItem = this.webComponentFactory.getWebComponent(NewsItem) as NewsItem;
      newsItem.model = news[i];
      documentFragment.appendChild(newsItem.load());
    }
    return documentFragment;
  }
}